import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Borrower, ProductParams, SESSION_STORAGE_KEYS, UPLOAD_DOCUMENT_DATA } from '../types/types';
import { UploadDocumentComponent } from '../components/upload-document/upload-document.component';
import { ModalController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  userSessionCreated = new Subject();

  constructor(private modalController: ModalController) { }

  setDataToSessionStorage({ key, data }: { key: SESSION_STORAGE_KEYS; data: any }) {
    const encryptedData = this.encryptData(data);
    localStorage.setItem(key, encryptedData);
  }

  removeDataToSessionStorage(key: SESSION_STORAGE_KEYS) {
    localStorage.removeItem(key);
  }

  getDataFromSessionStorage(key: SESSION_STORAGE_KEYS) {
    const encryptedData = localStorage.getItem(key);
    if (encryptedData) {
      return this.decryptData(encryptedData);
    }
    return null;
  }

  encryptData(data: any) {
    const stringData = JSON.stringify(data);
    return CryptoJS.AES.encrypt(stringData, environment.SECRET_KEY).toString();
  }

  decryptData(ciphertext: string): any {
    try {
      const bytes = CryptoJS.AES.decrypt(ciphertext, environment.SECRET_KEY);
      const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
      return new Function('return ' + decryptedText)();
    } catch (error) {
      return null;
    }
  }

  getAgeFromDob(date_of_birth: string) {
    if (!date_of_birth) {
      return '';
    }
    const dob = new Date(date_of_birth);
    const today = new Date();

    let age = today.getFullYear() - dob.getFullYear();
    const monthDifference = today.getMonth() - dob.getMonth();

    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < dob.getDate())) {
      age--;
    }

    return age;
  }

  clearGrantSession() {
    this.removeDataToSessionStorage(SESSION_STORAGE_KEYS.ACTIVE_CONTEXT)
    this.removeDataToSessionStorage(SESSION_STORAGE_KEYS.TRANSACTION_ID)
    this.removeLocalStorageData()
  }

  removeLocalStorageData() {
    Object.keys(localStorage).forEach((key) => {
      if (!Object.values(SESSION_STORAGE_KEYS).includes(key as SESSION_STORAGE_KEYS)) {
        localStorage.removeItem(key)
      }
    })
  }

  mapProductParams(borrower: Borrower) {
    try {
      const age = this.getAgeFromDob(borrower?.dob);
      const location = borrower?.state || borrower?.district || borrower?.city || ''
      const product_params = {
        borrowerId: borrower.id,
        age: age || '',
        gender: borrower?.gender?.toLowerCase() || '',
        location: location?.toLowerCase(),
        borrower_name: borrower?.first_name + ' ' + borrower?.last_name || ''
      }
      const encrypted_params = this.encryptData(product_params)
      return encrypted_params || null
    } catch (error) {
      return null
    }

  }
  getProductParamsFromUrl(encrypted_params: string) {
    try {
      const decrypted_params = this.decryptData(encrypted_params)
      return decrypted_params || null
    } catch (error) {
      return null;
    }
  }
  clearSessionStorage() {
    localStorage.clear();
  }

  setTransactionIdWithProductParams(transaction_id:string,encrypted_roduct_params:string){
    localStorage.setItem(transaction_id,encrypted_roduct_params)
  }
}
